/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Not_Found1Inputs */

const vi_cmspost_not_found1 = /** @type {(inputs: Cmspost_Not_Found1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bài viết này — có thể đã bị xoá.`)
};

/**

* @param {Cmspost_Not_Found1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_not_found1 = /** @type {((inputs?: Cmspost_Not_Found1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Not_Found1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_not_found1(inputs)
});
export { cmspost_not_found1 as "cmsPost_not_found" }